import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "@/config/antd";
import AttendeeCard from "./Attendee_Card";
import "@/assets/styles/attendees_modal.css";
import { useDispatch, useSelector } from "react-redux";
import {
  selectMultipleUsers,
  fetchMultipleUsersAsync,
  selectIsLoadingMultiple,
} from "@/store/redux/slices/user/user_slice";

const AttendeesTab = ({ members = [] }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const users = useSelector(selectMultipleUsers);
  const isLoading = useSelector(selectIsLoadingMultiple);

  // Feature flag to toggle attendee data fetching
  const enableAttendeesFetch = false; // Set to true when endpoint is fixed

  useEffect(() => {
    if (enableAttendeesFetch && members.length > 0) {
      dispatch(fetchMultipleUsersAsync(members));
    }
  }, [dispatch, members, enableAttendeesFetch]);

  const attendees = users.map((user) => ({
    id: user._id,
    name: user.fullname,
    avatar: user.profileImage || null,
    confirmed: true,
    username: user.username,
  }));

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Check if we have attendees to display
  const hasAttendees = enableAttendeesFetch && attendees.length > 0;

  return (
    <div className="w-full">
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-darkGrey">Attendees</h3>
            {hasAttendees && (
              <Button
                type="link"
                className="text-primary font-bold"
                onClick={showModal}>
                VIEW ALL
              </Button>
            )}
          </div>

          {hasAttendees ? (
            <div className="space-y-4">
              {attendees.map((attendee) => (
                <AttendeeCard
                  key={attendee.id}
                  attendee={attendee}
                  onClose={() => {}}
                />
              ))}
            </div>
          ) : (
            <div className="py-10 text-center bg-gray rounded-lg">
              <p className="text-gray">No attendees for this event yet.</p>
            </div>
          )}

          <Modal
            title="Attendees"
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
            width={600}
            className="attendees-modal">
            <div className="space-y-4 max-h-[60vh] overflow-y-auto">
              {attendees.map((attendee) => (
                <AttendeeCard
                  onClose={handleCancel}
                  key={attendee.id}
                  attendee={attendee}
                />
              ))}
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};

export default AttendeesTab;

AttendeesTab.propTypes = {
  members: PropTypes.array,
};
